import React from 'react';
import { Avatar } from '@bufferapp/ui';
import { PostComment } from '~/post/types';
import { formatDistanceToNow } from 'date-fns';
import { useAccount } from '~/accountContext';
import {
  CommentWrapper,
  AvatarWrapper,
  TextWrapper,
  Label,
  AuthorText,
  CreatedAtText,
  CommentText,
  DeleteComment,
} from './styles';

type Props = {
  comment: PostComment;
  onDelete: () => void;
};

export const Comment = ({ comment, onDelete }: Props) => {
  const account = useAccount();
  const { id: accountId } = account?.account;
  const { text, createdAt, author } = comment;
  const { id: authorId, email } = author;

  const isCommentCreator = accountId === authorId;

  return (
    <CommentWrapper>
      <AvatarWrapper>
        <Avatar
          src="https://s3.amazonaws.com/buffer-ui/Default+Avatar.png"
          alt="default-avatar"
          size="small"
        />
      </AvatarWrapper>
      {isCommentCreator && <DeleteComment onClick={onDelete} />}
      <TextWrapper>
        <Label>
          <AuthorText type="label" isCommentCreator={isCommentCreator}>
            {email}
          </AuthorText>
          <CreatedAtText type="label" color="gray">
            {`${formatDistanceToNow(createdAt * 1000)} ago`}
          </CreatedAtText>
        </Label>
        <CommentText>{text}</CommentText>
      </TextWrapper>
    </CommentWrapper>
  );
};
